import clsx from 'clsx';
import { useState } from 'react';
import LazyLoad from 'react-lazyload';
import { Direction } from 'types/Utilities';
import BeforeAfterPhotosContainer from 'components/Shared/BeforeAfter/BeforeAfterPhotosContainer';
import Icon from 'components/ui/Icon';
import tailwind from 'utils/breakpoints';
import { useTranslation } from 'hooks/useTranslation';
import { RecordType } from 'types/BeforeAfterPhotos';
import type { APIBeforeAfterPhoto } from 'types/BeforeAfterPhotos';
import type { ClinicPage } from 'types/Clinic';

type Props = {
  beforeAfterPhotos: APIBeforeAfterPhoto[];
  baPhotosTotalCount?: string | number;
  clinic: ClinicPage;
};

const BeforeAfter = ({
  beforeAfterPhotos,
  baPhotosTotalCount,
  clinic,
}: Props): JSX.Element | null => {
  const { t } = useTranslation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const photos: APIBeforeAfterPhoto[] | undefined =
    beforeAfterPhotos as unknown as APIBeforeAfterPhoto[];

  if (!photos.length) {
    return null;
  }

  return (
    <LazyLoad once>
      <div id="ba" className="border-t border-silver-light md:pt-18">
        <div className="max-w-screen-xl mx-auto px-5 md:px-4">
          <div className="md:grid grid-cols-3">
            <div className="flex justify-between items-center md:items-start">
              <h2 className="adelle-bold-section-headline">
                {t('doctorProfile.beforeAfterPhotos.title')}
              </h2>
              <Icon
                type="Arrow"
                direction={isCollapsed ? Direction.BOTTOM : Direction.TOP}
                onClick={() => setIsCollapsed(!isCollapsed)}
                className="md:hidden h-4 w-4 mb-6 text-navy stroke-current mt-12"
                color={tailwind.theme.backgroundColor.navy}
              />
            </div>
            <div
              className={clsx(
                isCollapsed && 'hidden',
                'lg:block col-span-2 text-charcoal',
              )}
            >
              <div className="mb-12 relative">
                <BeforeAfterPhotosContainer
                  slug={clinic.slug as string}
                  type={RecordType.CLINIC}
                  initialPhotos={photos}
                  totalCount={baPhotosTotalCount}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LazyLoad>
  );
};

export default BeforeAfter;
